<template>
    <v-container>
        <p class="font-weight-black display-4">Changelog</p>
        <vue-markdown class="my-8 mx-2" v-bind:emoji="false" v-if="this.markdown" v-bind:source="this.markdown"></vue-markdown>
        <v-progress-linear v-else indeterminate></v-progress-linear>
    </v-container>
</template>

<script>
    import VueMarkdown from 'vue-markdown';

    export default {
        name: "Changelog",
        head: {
            title: {
                inner: 'Changelog'
            },
            meta: [
            ],
            link: [
            ]
        },
        components: {
            VueMarkdown
        },
        data: function () {
            return {
                markdown: ''
            }
        },
        created() {
            this.fetchMarkdown();
        },
        mounted() {
        },
        methods: {
            fetchMarkdown: function () {
                this.axios.get("https://raw.githubusercontent.com/FinGameWorks/Changelog/master/Diffuse.md").then((response) => {
                    if (response.status === 200)
                    {
                        this.markdown = response.data;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>